// extracted by mini-css-extract-plugin
module.exports = {"group":"RadioGroup_group__oCFBa","option":"RadioGroup_option__2jKIQ","icon":"RadioGroup_icon__106ak","checked":"RadioGroup_checked__2uSnu","text":"RadioGroup_text__2zxOt"};